import {createSlice} from '@reduxjs/toolkit';
import { toast } from 'sonner';


let icoPlaceHodler = [
    {
        "_id": "67c4860ffdfdd7d88a8c9663",
        "phase": 1,
        "tokenAllocation": 50000000,
        "tokenPrice": 0.0000037,
        "totalSolTarget": 180,
        "totalBonusTokens": 5000000,
        "tokensSold": 0,
        "solRaised": 0,
        "status": "upcoming",
        "progress": 0,
        "started": false,
        "ended": false,
        "createdAt": "2025-03-02T16:23:43.507Z",
        "updatedAt": "2025-03-13T13:29:12.957Z",
        "__v": 0,
        "bonusPercent": 10,
        "endDate": "2025-04-10T00:00:00.000Z",
        "startDate": "2025-03-18T12:08:42.000Z",
        "maxBuy": 7,
        "transactions": []
    },
    {
        "_id": "67cd8d50935c9dc46d584575",
        "phase": 2,
        "tokenAllocation": 100000000,
        "tokenPrice": 0.0000038,
        "totalSolTarget": 380,
        "bonusPercent": 2,
        "totalBonusTokens": 2000000,
        "tokensSold": 0,
        "solRaised": 0,
        "status": "upcoming",
        "progress": 0,
        "started": false,
        "ended": false,
        "maxBuy": 7,
        "createdAt": "2025-03-09T12:45:04.915Z",
        "updatedAt": "2025-03-13T13:28:11.249Z",
        "__v": 0,
        "transactions": []
    }
]

export const userSessionSlice = createSlice({
   name : 'userSession',
    initialState:{
       userSession:null,
       ico:icoPlaceHodler,
       isLoading:{
        ico:false,
        userSession:false
       },
       isError:{
        ico:false,
        userSession:false
       },
       promise:{
        ico:{
            isLoading:false,
            isError:false,
            success:false,
        },
        userSession:{
            isLoading:false,
            isError:false,
            success:false,
        },
       },
        
    },
    reducers:{
        setIcoData:(state,action)=>{
            state.ico = action.payload
        },
        setUserSessionData:(state,action)=>{
            state.userSession ={...state.userSession,...action.payload}
        },
        setWhitelist:(state,action)=>{
        state.whitelist=action.payload
        },
        setTradingData : (state,action)=>{
            state.tradingData = {...state.tradingData ,...action.payload}
        },
        setSocket:(state,action)=> {
            state.socket =action.payload
        },
        logout:(state,action)=> {
            state.userSession =null
        },
        setIsDataLoading:(state,action)=> {
            state.isLoading ={...state.isLoading , ...action.payload}
        },
        setIsDataError:(state,action)=> {
            state.isError ={...state.isError , ...action.payload}
        },
        
        setPromise:(state,action)=> {
            state.promise ={...state.promise , ...action.payload}
        },
        

    }
})



export const {
    setWhitelist,
    setIcoData,
    setUserSessionData,
    logout,
    setIsDataLoading,
    setIsDataError,
    setPromise


} = userSessionSlice.actions

export const selectIcoData =(state)=>state.userSession.ico
export const selectUserSessionData =(state)=>state.userSession.userSession
export const selectIsDataLoading =(state)=>state.userSession.isLoading
export const selectIsDataError=(state)=>state.userSession.isError
export const selectPromise=(state)=>state.userSession.promise


